import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useSerialnoListMutation,
  useTotalcountserialnoMutation
} from "../../../../store/api/serialnoapi";
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
// import SearchFilters from "../../../../Core/SearchFilters/SearchFilters";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
import ExportCSV from '../../../../Core/Export/ExportCSV'
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import { useDeleteDocMutation } from "../../../../store/api/globalapi";
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../../utils/useScreenHeight";
const MainContent = () => {
  const navigate = useNavigate();
  const { screenHeight, screenScaling,pageSize } = useScreenHeight();
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setCountItemData] = useState(0);
  const [purchaseData, setPurchaseData] = useState({
    purchase_order: [],
    total_no_of_records: 0,
  });
  const [itemserialnolist] = useSerialnoListMutation();
  const [totalcountserialno] = useTotalcountserialnoMutation();
  const [showColumnConfig, setShowColumnConfig] = useState(false);
  const [showExportPopup, setShowExportPopup] = useState(false);
  const [showFilters, setShowFilters] = useState(false)

  //states used for deleting the record
  const [deleteDoc] = useDeleteDocMutation();
  const [delPopupVisible, setDelPopupVisible] = useState(false);
  const [delSelectedId, setDelSelectedId] = useState(null);
  const [delmessage, setDelmessage] = useState();
  const [alreadySubmitData, setAlreadySubmitData] = useState(false);
  const [delDone, setDelDone] = useState(false);

  const filtersConfig = [
    { name: "siNo", label: "S. No.", type: 'number', width: "3.6%" },
    { name: "name", label: "Id", width: "12%", type: 'text' },
    { name: "item_code", label: "Item Code", width: "12%", type: 'text' },
    { name: "warehouse", label: "Warehouse", width: "12%", type: 'text' },
    { name: "company", label: "Company", width: "12%", type: 'text' },
    { name: 'creation', label: 'Date', type: 'date', width: '12%' },
    {
      name: "status",
      label: "Status",
      width: "12%",
      type: "select",
      options: [
        { value: "Active", label: "Active" },
        { value: "Inactive", label: "Inactive" },
        { value: "Consumed", label: "Consumed" },
        { value: "Delivered", label: "Delivered" },
        { value: "Expired", label: "Expired" },

      ],
    },
  ];

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };
  const handleView = (id) => {
    try {
      navigate(`/master/serialno/serialno-view/`, { state: { ItemId: id } });
    } catch (err) {
      console.error("Edit failed:", err);
    }
  };
  const handleEdit = async (id) => {
    try {
      navigate(`/master/serialno/serialno-edit/`, { state: { ItemId: id } });
    } catch (err) {
      console.error("Edit failed:", err);
    }
  };
  const handleDelete = (id) => {
    setDelSelectedId(id);
    setDelPopupVisible(true);
    setAlreadySubmitData(false);
    setDelmessage("Are you sure you want to Delete this Serial No?");
  };

  const delHandleCancel = () => {
    setDelPopupVisible(false);
    setDelSelectedId(null);
  };

  const delHandleConfirm = async () => {
    try {
      await deleteDoc({
        doctype: "Serial No",
        name: delSelectedId,
      }).unwrap();
      setDelmessage(`Serial No ${delSelectedId} deleted successfully!`);
      setDelDone(true);
      setTimeout(() => {
        setDelPopupVisible(false);
        setDelSelectedId(null);
        setDelDone(false);
        getData();
        getCountData();
      }, 1000);
    } catch (err) {
      console.error("Deletion Failed:", err);

      let errorMessage = "Failed to delete the Serial No!";

      //If the server is sending the error message , we will extract it.
      if (err?.data?._server_messages) {
        try {
          const messageArr = JSON.parse(err.data._server_messages);
          if (messageArr && messageArr.length > 0) {
            //parse inner json object
            const messageObj = JSON.parse(messageArr[0]);
            if (messageObj?.message) {
              //extract the exact message we want
              const fullMessage = messageObj.message;
              errorMessage = fullMessage.split("You must")[0].trim();
              //remove html in the message
              errorMessage = errorMessage.replace(/<[^>]+>/g, "");
            }
          }
        } catch (parseError) {
          console.error("Error parsing server messages:", parseError);
        }
      }
      setDelPopupVisible(true);
      setDelmessage(errorMessage);
      setAlreadySubmitData(true);
    } finally {
      // setTimeout(() => {
      //     setDelPopupVisible(false);
      //     setDelSelectedId(null);
      // }, 2000);
    }
  };

  const [columnsConfig, setColumnsConfig] = useState(() => [

    {
      header: "S. No.",
      name: "S. No.",
      accessor: "siNo",
      width: "6%",
      visible: true,
      sortable: false, // avoid enabling sort unless you manage it manually
      cellRenderer: (row) => row.siNo, // fallback also handled above
    },
    {
      header: "Id",
      name: "Id",
      visible: true,
      accessor: "name",
      width: "15%",
      sortable: true,
    },
    {
      header: "Item Code",
      name: "Item Code",
      visible: false,
      accessor: "item_code",
      width: "14.3%",
      sortable: true,
    },
    {
      header: "Warehouse",
      name: "Warehouse",
      visible: true,
      accessor: "warehouse",
      width: "14.6%",
      sortable: false,
    },
    {
      header: "Company",
      name: "Company",
      visible: false,
      accessor: "company",
      width: "14.7%",
      sortable: false,
    },

    {
      header: "Date",
      accessor: "creation",
      sortable: true,
      visible: true,
      name: 'Date',
      width: '20%',
      cellRenderer: (row) => row.creation?.split(" ")[0],
    },
    {

      header: "Status",
      name: "Status",
      accessor: "status",
      visible: true,
      width: "14%",
      sortable: false,
      cellRenderer: (row) => {
        const label = row.status;
        let color = "";
        switch (label) {
          case "Active":
            color = "#a0dbc6ff";
            break;
          case "Inactive":
            color = "#D97706";
            break;
          case "Delivered":
            color = "#178961"
            break;
          case "Consumed":
            color = "#1e21adff";
            break;
          case "Expired":
            color = "#ba1717ff";
            break;
          default:
            color = "#000000";
        }

        return <span style={{ color }}>{label}</span>;
      },
    },

    {
      header: "Action",
      name: "Action",
      accessor: 'action',
      visible: true,
      width: "10%",
      sortable: false,
      cellRenderer: (row) => (
        <ActionButtonDropdown
          id={row.name}
          onView={() => handleView(row.name)}
          onEdit={() => handleEdit(row.name)}
          onDelete={() => handleDelete(row.name)}
        />
      ),
    },
  ]
  );
  // Handle column configuration changes
  const handleSaveColumns = (selectedKeys, allFields) => {
    const updatedColumns = columnsConfig.map(column => {
      return {
        ...column,
        visible: selectedKeys.includes(column.accessor)
      };
    });
    setColumnsConfig(updatedColumns);
  };

  const visibleColumns = useMemo(() =>
    columnsConfig.filter(col => col.visible === true),
    [columnsConfig]
  );

  const defaultSelectedColumns = useMemo(() =>
    columnsConfig
      .filter(col => col.visible === true)
      .map(col => ({
        fieldname: col.accessor,
        label: col.name
      }))
      .filter(col => col.fieldname),
    [columnsConfig]
  );
  const activeFilterCount = useMemo(() => {
    return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
  }, [filters]);
  const actionButtons = [
    {
      className: "createbtn border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "IoFilterSharp",
      iconSize: 12,
      children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
      onClick: () => {
        setShowFilters(prev => !prev);
        setShowColumnConfig(false);
      }
    },
    {
      className: "createbtn border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "MdOutlineRemoveRedEye",
      iconSize: 12,
      children: "Show more",
      onClick: () => {
        setShowColumnConfig(prev => !prev);
        setShowFilters(false);
      }
    },
    {
      className: "createbtn border-0 d-flex",
      style: { gap: "2px", height: "28px" },
      iconName: "RiFileExcel2Fill",
      iconSize: 12,
      children: "Export Excel",
      onClick: () => setShowExportPopup(true),
    },
    //  {
    //         className: "importbtn",
    //         style: { backgroundColor: '#fff', height: '28px' },
    //         iconName: "IoMdArrowDropdown",
    //         iconSize: 14,
    //         iconPosition: "right",
    //         iconBoxClassName: "ps-2",
    //         children: "Last Updated On"
    //     },
    {
      className: "custom-btn-00989 d-flex",
      to: "/master/serialno/serialno-create",
      iconName: "FiPlus",
      style: { gap: "2px", height: "28px" },
      children: "Add Serial No",
    },
  ];

  const getData = async () => {
    setLoading(true);
    try {
      // STEP 1: Clean filters
      const filteredSearchInput = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value !== '' && value !== undefined && value !== null) {
          acc[key] = value;
        }
        return acc;
      }, {});

      const siNoFilter = filteredSearchInput.siNo;
      const isSiNoFilterActive = siNoFilter !== undefined && siNoFilter !== "";

      // STEP 2: Remove siNo from API filter
      const frappeFilters = Object.entries(filteredSearchInput)
        .filter(([key]) => key !== "siNo")
        .map(([key, value]) => {
          if (key === "creation") {
            return ["Serial No", key, "=", value];
          }
          if (key === "status") {
            return ["Serial No", key, "=", value];
          }
          return ["Serial No", key, "like", `%${value}%`];
        });


      // STEP 3: If filtering by siNo, jump to that page
      const targetPage = isSiNoFilterActive
        ? Math.ceil(parseInt(siNoFilter, 10) / pageSize)
        : currentPage;

      const payload = {
        start: pageSize * (targetPage - 1),
        limit: pageSize,
        filters: frappeFilters,
        fields: [
          "name",
          "item_code",
          "warehouse",
          "company",
          "creation",
          "status",
        ],
      };

      const response = await itemserialnolist(payload);
      const rawData = response.data.data;

      // STEP 4: Assign global serial numbers
      const numberedData = rawData.map((item, index) => ({
        ...item,
        siNo: index + 1 + pageSize * (targetPage - 1),
      }));

      // STEP 5: If siNo is used, filter client-side
      const finalData = isSiNoFilterActive
        ? numberedData.filter((item) => item.siNo === parseInt(siNoFilter, 10))
        : numberedData;

      setPurchaseData(finalData);

      // Optional: update currentPage to reflect jump
      if (isSiNoFilterActive) setCurrentPage(targetPage);
    } catch (error) {
      console.error("Error fetching item:", error);
    } finally {
      setLoading(false);
    }
  };
  const getCountData = async () => {
    setLoading(true);
    try {
      const response = await totalcountserialno();
      if (response?.data) {
        setCountItemData(response?.data);
        //   console.log('count:', response?.data);
      }
    } catch (error) {
      console.error("Error fetching item count:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
		
		if (pageSize > 0) {
			getData();
			getCountData();
		}
	}, [
		currentPage,
		filters,
		itemserialnolist,
		totalcountserialno,
		pageSize,
		screenHeight,
		screenScaling
	]);
  const accessors = columnsConfig
		.filter(
			(column) => column.accessor !== "siNo" && column.accessor !== "action"
		)
		.map((column) => column.accessor);

  return (
    <div className="container-fluid d-flex flex-column " style={{ flexGrow: '1' }}>
      <Tabs />
      <ListLayout
        breadcrumbItems={[{ label: "Serial No" }, { label: "Serial No List", style: { borderBottom: "0px solid", textWrap: "nowrap", gap: '5px', color: "#270B79", fontSize: '' } }]}
        actionButtons={actionButtons}
      >
        {
          showFilters && <ListFilters
            filtersConfig={filtersConfig}
            onFilterChange={handleFilterChange}
            currentFilters={filters}
            setShowFilters={setShowFilters}
          />
        }
        {showColumnConfig &&
          <ConfigureColumnsNew
            show={showColumnConfig}
            onClose={() => setShowColumnConfig(false)}
            onSave={handleSaveColumns}
            docType="Serial No"
            defaultSelected={defaultSelectedColumns}
            fieldsData={columnsConfig.map(col => ({
              fieldname: col.accessor,
              label: col.name
            }))}
            disabledFields={["siNo", "creation", "action", "status", "name"]}
          />}

        <Table columns={visibleColumns} data={purchaseData} loading={loading} />

        <Pagination
          setCurrentPage={setCurrentPage}
          pageSize={pageSize}
          totalRecords={totalRecords.message}
          currentPage={currentPage}
          className="mt-2 pb-3"
        />
        {delPopupVisible && (
          
					<DelConfirmPopup
						alredysubmitdata={alreadySubmitData}
						delSelectedId={delSelectedId}
						visible={delPopupVisible}
						message={delmessage}
						onConfirm={delHandleConfirm}
						onCancel={delHandleCancel}
						delDone={delDone}
					/>
        )}
        

      {showExportPopup && (
        <ExportCSV
            doctype="Serial No"
            fieldsData={accessors}
        onClose={() => setShowExportPopup(false)}
        />
      )}

      </ListLayout>

    </div>
  );
};

export default MainContent;
